module.exports = __webpack_public_path__ + "static/img/sport_3.2b00786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport_3.png
// module id = Hrr/
// module chunks = 0